import { render } from "./ServiceOrderDataNew.vue?vue&type=template&id=d0f4c8da&scoped=true"
import script from "./ServiceOrderDataNew.vue?vue&type=script&lang=js"
export * from "./ServiceOrderDataNew.vue?vue&type=script&lang=js"

import "./ServiceOrderDataNew.vue?vue&type=style&index=0&id=d0f4c8da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f4c8da"]])

export default __exports__